import React from "react";
import { ModalBase } from "../../ModalBase";
import { Text } from "../../Text";

type Props = {
  isOpen: boolean;
  locationConsumption: string;
  locationName: string;
  numTonnesPerPerson: number;
  onClose: () => void;
};

export const HowPlanCalculatedModal: React.FC<Props> = (props) => {
  const {
    isOpen,
    onClose,
    numTonnesPerPerson,
    locationConsumption,
    locationName,
  } = props;

  const liStyle = { listStyle: "inherit", paddingBottom: "10px" };

  return (
    <ModalBase
      isOpen={isOpen}
      onClose={onClose}
      title="How is this calculated?"
    >
      <Text>
        Based on your location, your region <strong>{locationName}</strong>{" "}
        falls in to the <strong>{locationConsumption}</strong> emissions
        category. The average carbon footprint of a resident of your country is{" "}
        <strong>{numTonnesPerPerson}T</strong> CO<sub>2</sub>e and an Ecologi
        subscription will more than avoid this by funding climate action.
      </Text>
      <br />
      <Text>
        To calculate this footprint, Ecologi combines multiple data sets:
      </Text>
      <ol style={{ listStyle: "decimal", padding: "0 0 0 16px" }}>
        <li style={liStyle}>
          <Text>
            Data from the{" "}
            <a
              href="https://data.worldbank.org/indicator/EN.ATM.CO2E.PC"
              title="View World Bank website (new tab)"
              target="_blank"
              rel="noopener noreferrer"
              className="link"
            >
              World Bank
            </a>{" "}
            which reports CO2 and other greenhouse emissions that occur in your
            country.
          </Text>
        </li>
        <li style={liStyle}>
          <Text>
            Data from the{" "}
            <a
              href="https://www.globalcarbonproject.org/carbonbudget/21/data.htm"
              title="View Global Carbon Project website (new tab)"
              target="_blank"
              rel="noopener noreferrer"
              className="link"
            >
              Global Carbon Project
            </a>{" "}
            which reports emissions embedded in imports from overseas. We
            combine these imported emissions with the country of residence
            emissions.
          </Text>
        </li>
        <li style={{ ...liStyle, padding: 0 }}>
          <Text>
            An additional 10% to ensure that each member is becoming climate
            positive by avoiding more than their footprint.
          </Text>
        </li>
      </ol>
    </ModalBase>
  );
};
